/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'
import { get } from 'lodash'

/**
 *     Import
 *     - Components
 */
import { DropdownArrowIcon } from '../../../../images/icons/DropdownArrow/DropdownArrow'
import AddressBlock from '../../Quote/Step02/components/AddressBlock'

export default class VariantBlock extends React.Component<any, any> {

    constructor(props: any) {
        super(props)
        this.state = {
            sectionsOpen: false,
        }
    }

    handleSectionClick = () => this.setState({ sectionsOpen: !this.state.sectionsOpen })

    handleBindQuote = () => this.props.bindQuoteVariation(this.props.variation)

    handleIssueQuote = () => this.props.issueViewQuoteVariation(this.props.quoteId, this.props.variation.id)

    handleReissueQuote = () => this.props.handleReissueQuote(this.props.quoteId, this.props.variation.id)

    render() {
        const { isCollectors, isMuseums, isWineSpirits } = this.props
        let riskLocations = get(this.props, 'riskLocations.response')
        return (
            <div className="quote__view__varblock" id={`varblock_${this.props.index}`}>
                <div className="quote__view__header">
                    <span className="medium">Quote {this.props.index + 1}</span>
                    <span>Premium:</span>
                    <div>{(this.props.variation.premium).toLocaleString('en-GB', {
                        style: 'currency',
                        currency: 'GBP',
                    })} <span>inc.IPT</span></div>
                </div>

                <div className="quote__view__container">
                    <div className="quote__view__block quote__view__block--big">
                        <div>Quote ref no.</div>
                        <span>{this.props.variation.quoteRef}</span>
                    </div>

                    <div className="quote__view__block quote__view__block--big">
                        <div>Your commission:</div>
                        <span>{this.props.variation.commission}%</span>
                    </div>

                    <div className="quote__view__block quote__view__block--big">
                        <div>Excess:</div>
                        <span>
                            {(typeof (this.props.variation.excess) === 'number') ?
                                (this.props.variation.excess).toLocaleString('en-GB', {
                                    style: 'currency',
                                    currency: 'GBP',
                                })
                                : `£${this.props.variation.excess}`
                            }
                        </span>
                    </div>
                    {((isCollectors || isMuseums || isWineSpirits) && this.props.variation.experiencedRate) ?
                        <div className="quote__view__block quote__view__block--big">
                            <div>Bespoke Rate:</div>
                            <span>{this.props.variation.experiencedRate}%</span>
                        </div> : null}

                </div>

                <div className="quote__view__sections">
                    <div
                        onClick={this.handleSectionClick}
                        className={`quote__view__sections__button ${this.state.sectionsOpen ? 'open' : null}`}
                    >
                        <span>
                            {(isCollectors || isMuseums || isWineSpirits) ? 'Risk address' : 'Operative sections'}
                        </span>
                        <DropdownArrowIcon color={`#fca61b`} />
                    </div>

                    <div className={`quote__view__sections__list ${this.state.sectionsOpen ? 'open' : null}`}>
                        {((isCollectors || isMuseums || isWineSpirits) && riskLocations) ?
                            riskLocations.map((r, i) => {
                                return (
                                    <AddressBlock
                                        key={i}
                                        id={r.id}
                                        quoteId={parseInt(r.quoteId, 10)}
                                        addressType={r.addressType}
                                        addressLine1={r.addressLine1}
                                        addressLine2={r.addressLine2}
                                        city={r.city}
                                        postcode={r.postcode}
                                        addressAllocated={r.allocated}
                                    />
                                )
                            }) :
                            this.props.variation.operativeSections.map((item, index) => (
                                <div key={'section' + index}>{item}</div>
                            ))}
                    </div>
                </div>

                <div
                    className="quote__view__action"
                    onClick={this.handleBindQuote}
                >
                    Bind quote
                </div>
                {
                    (!this.props.variation.isIssued) ?
                        <div
                            className="quote__view__action"
                            onClick={this.handleIssueQuote}
                        >
                            Issue quote
                        </div> :
                        <div
                            className="quote__view__action"
                            onClick={this.handleReissueQuote}
                        >
                            Download quote
                        </div>
                }
            </div >
        )
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Quote/ViewQuote/VariantBlock.tsx